import {
  setupBulkDomainSearch,
  setupDomainSearchModeSelection
} from './domain-search'

/**
 * @description Bootstraps the domain search page
 */
export const setupDomainSearch = (): void => {
  setupDomainSearchModeSelection()
  setupBulkDomainSearch()
}
